'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var middleMixin = exports.middleMixin = {
  '&:before': {
    display: 'inline-block',
    height: '100%',
    verticalAlign: 'middle',
    content: '""',
    width: 0
  },
  '& > *': {
    verticalAlign: 'middle'
  }
};

var borderMixin = exports.borderMixin = function borderMixin(color) {
  return {
    boxShadow: 'inset 0 0 0 1px ' + color
  };
};

var topBorderMixin = exports.topBorderMixin = function topBorderMixin(color) {
  return {
    boxShadow: 'inset 0 1px 0px ' + color
  };
};

var bottomBorderMixin = exports.bottomBorderMixin = function bottomBorderMixin(color) {
  return {
    boxShadow: 'inset 0 -1px 0px ' + color
  };
};

var isolateMixin = exports.isolateMixin = {
  borderCollapse: 'separate',
  borderSpacing: 0,
  borderRadius: 0,
  captionSide: 'top',
  cursor: 'auto',
  direction: 'ltr',
  emptyCells: 'show',
  fontFamily: 'inherit',
  fontSize: 'medium',
  fontStyle: 'normal',
  fontVariant: 'normal',
  fontWeight: 'normal',
  fontStretch: 'normal',
  lineHeight: 'normal',
  verticalAlign: 'baseline',
  hyphens: 'none',
  letterSpacing: 'normal',
  listStyle: 'disc outside none',
  tabSize: '8',
  textAlign: 'left',
  textAlignLast: 'auto',
  textIndent: '0',
  textShadow: 'none',
  textTransform: 'none',
  visibility: 'visible',
  whiteSpace: 'normal',
  widows: '2',
  wordSpacing: 'normal',
  padding: 0,
  margin: 0
};

var responsiveFactory = function responsiveFactory(rule) {
  return function (options) {
    return _defineProperty({}, rule, options);
  };
};

var ifDesktop = exports.ifDesktop = responsiveFactory('@media (min-device-width: 768px)');

var ifMobile = exports.ifMobile = responsiveFactory('@media (max-device-width: 767px)');

var ifDesktopSize = exports.ifDesktopSize = responsiveFactory('@media (min-width: 768px)');

var pseudoSelectors = ['::-webkit-input-placeholder', '::-moz-placeholder', ':-moz-placeholder', ':-ms-input-placeholder', '::placeholder'];
var placeholderMixin = exports.placeholderMixin = function placeholderMixin(selector, style) {
  return pseudoSelectors.reduce(function (result, pseudo) {
    return _extends({}, result, _defineProperty({}, '' + selector + pseudo, style));
  }, {});
};

var fontSmoothingMixin = exports.fontSmoothingMixin = {
  '-webkit-font-smoothing': 'antialiased',
  '-moz-osx-font-smoothing': 'grayscale'
};

var beautyScroll = exports.beautyScroll = function beautyScroll(selector) {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, selector + selector, {}), _defineProperty(_ref2, selector + ' > *', {}), _defineProperty(_ref2, selector + '::-webkit-scrollbar', {
    width: 4,
    backgroundColor: 'transparent'
  }), _defineProperty(_ref2, selector + '::-webkit-scrollbar-track', {
    '-webkit-box-shadow': 'none'
  }), _defineProperty(_ref2, selector + '::-webkit-scrollbar-thumb', {
    background: '#dcdfe7',
    borderRadius: 0
  }), _defineProperty(_ref2, selector + '::-webkit-scrollbar-track-piece', {}), _defineProperty(_ref2, selector + '::-webkit-scrollbar-button', {}), _defineProperty(_ref2, selector + '::-webkit-scrollbar-corner', {}), _defineProperty(_ref2, selector + '::-webkit-resizer', {}), _ref2;
};

/**
 * Applying styles on elements depending on focus event source type
 * @param {string} sourceType Other/pointer
 * @param {string} selector CSS-selector
 * @param {string} declaration CSS-declaration
 */
var focusSourceMixin = exports.focusSourceMixin = function focusSourceMixin() {
  var sourceType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'other';
  var selector = arguments[1];
  var declaration = arguments[2];
  return _defineProperty({}, 'html[data-focus-source="' + sourceType + '"] ' + selector, declaration);
};